export default "__VITE_ASSET__d3a839dd__"